import { render, staticRenderFns } from "./ClinicInvoicesModal.vue?vue&type=template&id=61e3718a&scoped=true&"
import script from "./ClinicInvoicesModal.vue?vue&type=script&lang=js&"
export * from "./ClinicInvoicesModal.vue?vue&type=script&lang=js&"
import style0 from "./ClinicInvoicesModal.vue?vue&type=style&index=0&id=61e3718a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3718a",
  null
  
)

export default component.exports